import { render } from "./Detictive.vue?vue&type=template&id=780c1f5e"
import script from "./Detictive.vue?vue&type=script&lang=js"
export * from "./Detictive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__